interface StatusBadgeProps {
  status: string;
}

export function StatusBadge({ status }: StatusBadgeProps) {
  const configs: Record<string, { bg: string; text: string; label: string }> = {
    TRIMIS: { bg: 'bg-gray-100', text: 'text-gray-700', label: 'Trimis' },
    CONTACTAT: { bg: 'bg-blue-100', text: 'text-blue-700', label: 'Contactat' },
    PROGRAMAT: { bg: 'bg-indigo-100', text: 'text-indigo-700', label: 'Programat' },
    PREZENTAT: { bg: 'bg-purple-100', text: 'text-purple-700', label: 'Prezentat' },
    SERVICIU_PRESTAT: { bg: 'bg-orange-100', text: 'text-orange-700', label: 'Serviciu Prestat' },
    COMISION_ELIGIBIL: { bg: 'bg-green-100', text: 'text-green-700', label: 'Comision Eligibil' },
    PLATIT: { bg: 'bg-teal-100', text: 'text-teal-700', label: 'Plătit' },
    ANULAT: { bg: 'bg-red-100', text: 'text-red-700', label: 'Anulat' },
  };

  const config = configs[status] || configs.TRIMIS;

  return (
    <span className={`inline-flex items-center px-2.5 py-0.5 rounded-full text-xs font-medium ${config.bg} ${config.text}`}>
      {config.label}
    </span>
  );
}
